/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notice_SummaryInputs */

const en_notice_summary = /** @type {(inputs: Notice_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`More of your accounts moved today: see Hot right now`)
};

/**
* | output |
* | --- |
* | "More of your accounts moved today: see Hot right now" |
*
* @param {Notice_SummaryInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const notice_summary = /** @type {((inputs?: Notice_SummaryInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notice_SummaryInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_notice_summary(inputs)
});